import Button from 'components/actions/Button';
import CreateSimulationDialog from 'features/simulations-v2/CreateSimulationDialog';
import SimulationsV2Table from 'features/simulations-v2/SimulationsV2Table';
import type { Scenario } from 'features/simulations-v2/types';
import useGetSimulationsV2 from 'hooks/useGetSimulationsV2';
import { useMemo, useState } from 'react';

interface Props {
    scenarios: Scenario[] | undefined;
    scenariosIsLoading: boolean;
    scenariosIsError: boolean;
}

const ActiveSimulationsTab = ({ scenarios, scenariosIsLoading, scenariosIsError }: Props) => {
    const { simulations, isLoading: simIsLoading, isError: simIsError, refresh } = useGetSimulationsV2();
    const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

    const scenarioNames = useMemo(() => new Map((scenarios ?? []).map(s => [s.id, s.name])), [scenarios]);

    const handleCreateSuccess = () => {
        setIsCreateDialogOpen(false);
        refresh();
    };

    return (
        <>
            <div className='SimulationsV2Page__tabContent'>
                <div className='SimulationsV2Page__tabHeader'>
                    <div>
                        <h5 className='SimulationsV2Page__tabTitle'>Active Simulations</h5>
                        <p>Overview of all currently running simulations</p>
                    </div>
                    <Button
                        data-testid='simulations-v2-create-button'
                        style='primary'
                        onClick={() => setIsCreateDialogOpen(true)}
                    >
                        <span className='rioglyph rioglyph-plus' />
                        Create simulation
                    </Button>
                </div>
            </div>
            <div>
                <SimulationsV2Table
                    simulations={simulations}
                    scenarioNames={scenarioNames}
                    isLoading={simIsLoading || scenariosIsLoading}
                    isError={simIsError || scenariosIsError}
                    refresh={refresh}
                />
            </div>
            <CreateSimulationDialog
                show={isCreateDialogOpen}
                scenarios={scenarios ?? []}
                onClose={() => setIsCreateDialogOpen(false)}
                onSuccess={handleCreateSuccess}
            />
        </>
    );
};

export default ActiveSimulationsTab;
